import React from 'react';

const CaptchaVerification = ({
  selectedCaptcha,
  onCaptchaSelect,
  hasError = false,
  captchaType = 'plane', // 'plane' or 'house'
  errorMessage
}) => {
  const handleCaptchaSelect = (selection) => {
    onCaptchaSelect(selection);
  };

  const captchaOptions = captchaType === 'house'
    ? [
        { id: 'star', emoji: '⭐' },
        { id: 'car', emoji: '🚗' },
        { id: 'house', emoji: '🏠' }
      ]
    : [
        { id: 'car', emoji: '🚗' },
        { id: 'truck', emoji: '🚛' },
        { id: 'plane', emoji: '✈️' }
      ];

  const targetEmoji = captchaType === 'house' ? 'house' : 'plane';
  const defaultErrorMessage = `Please select the ${targetEmoji} to continue.`;

  return (
    <div
      className="border-2 rounded p-4"
      style={{ borderColor: hasError ? '#ef4444' : '#db0058' }}
    >
      <p className="text-sm mb-4">
        Please prove you are human by selecting the <span style={{ color: '#db0058' }}>{targetEmoji}</span>.
      </p>
      {hasError && (
        <p className="text-red-500 text-sm mb-2">{errorMessage || defaultErrorMessage}</p>
      )}
      <div className="flex justify-center space-x-8">
        {captchaOptions.map(({ id, emoji }) => (
          <button
            key={id}
            type="button"
            onClick={() => handleCaptchaSelect(id)}
            className={`text-3xl transition-all duration-200 p-2 rounded-lg border-2 ${
              selectedCaptcha === id
                ? 'bg-opacity-20 scale-110'
                : 'border-transparent text-white hover:scale-105'
            }`}
            style={selectedCaptcha === id ? {
              borderColor: '#db0058',
              backgroundColor: '#db0058',
              color: '#db0058'
            } : {}}
            onMouseEnter={(e) => {
              if (selectedCaptcha !== id) {
                e.target.style.borderColor = '#db0058';
                e.target.style.color = '#db0058';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedCaptcha !== id) {
                e.target.style.borderColor = 'transparent';
                e.target.style.color = 'white';
              }
            }}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CaptchaVerification;